import type { ApolloCache } from '@frameio/graphql-client';
import {
  AssetTypename,
  type AssetTypenameFragment,
} from '../gql/generated/AssetTypename';

export type AssetType = AssetTypenameFragment['__typename'];

/**
 * gets the value of cache.readFragment for the AssetTypename fragment, which
 * provides only the id and __typename of an Asset.
 *
 * @param cache The apollo cache
 * @param id The id of the requested asset
 * @returns The AssetTypename fragment result
 */
export const getAssetTypename = (cache: ApolloCache<any>, id: string) =>
  cache.readFragment({
    fragment: AssetTypename,
    fragmentName: 'AssetTypename',
    id: cache.identify({
      __typename: 'Asset',
      id,
    }),
    returnPartialData: true,
  });
